/* eslint-disable */

export const updateNativeResolution = /* GraphQL */ `
  mutation UpdateNativeResolution(
    $input: UpdateNativeResolutionInput!
    $condition: ModelNativeResolutionConditionInput
  ) {
    updateNativeResolution(input: $input, condition: $condition) {
      id
      requiredResolutionID
      value
      type
      active
      verticalCut
      horizontalCut
      createdAt
      updatedAt
      requiredResolution {
        id
        value
        type
        createdAt
        updatedAt
        campaigns {
          nextToken
        }
        nativeResolutions {
          nextToken
        }
      }
      campaigns {
        items {
          id
          campaignID
          nativeResolutionID
          createdAt
          updatedAt
          campaign {
              id
              name
              end_time
              status
              automaticStatus
            }
        }
        nextToken
      }
    }
  }
`;
export const deleteAsset = /* GraphQL */ `
  mutation DeleteAsset(
    $input: DeleteAssetInput!
    $condition: ModelAssetConditionInput
  ) {
    deleteAsset(input: $input, condition: $condition) {
      id
    }
  }
`;

export const updateAssetViewers = /* GraphQL */ `
  mutation UpdateAssetViewers(
    $input: UpdateAssetInput!
    $condition: ModelAssetConditionInput
  ) {
    updateAsset(input: $input, condition: $condition) {
      viewers
    }
  }
`;